// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__wJ_ke","content":"GlobalSearch_content__2ohSH"};